[
  "abbreviate",
  "absence",
  "absorb",
  "abundant",
  "accelerate",
  "accept",
  "accessible",
  "accidentally",
  "accommodate",
  "accomplish",
  "accumulate",
  "accurate",
  "achieve",
  "acknowledge",
  "acquire",
  "actual",
  "adapt",
  "adequate",
  "adjust",
  "admire",
  "adolescent",
  "adopt",
  "advantage",
  "advertise",
  "advice",
  "aesthetic",
  "affect",
  "afford",
  "afterward",
  "aggressive",
  "agriculture",
  "aisle",
  "alien",
  "allies",
  "allocate",
  "allowance",
  "although",
  "aluminum",
  "amateur",
  "ambassador",
  "ambiguous",
  "ambulance",
  "amendment",
  "among",
  "analysis",
  "ancestor",
  "ancient",
  "anniversary",
  "announce",
  "annual",
  "anonymous",
  "antarctic",
  "anticipate",
  "anxiety",
  "apologize",
  "apparatus",
  "apparent",
  "appetite",
  "appreciate",
  "approach",
  "appropriate",
  "approximate",
  "aquarium",
  "arbitrary",
  "architect",
  "arctic",
  "argument",
  "arithmetic",
  "arrangement",
  "article",
  "artificial",
  "ascend",
  "ashamed",
  "assassination",
  "assessment",
  "assignment",
  "assistance",
  "associate",
  "assume",
  "assurance",
  "asterisk",
  "asthma",
  "astonish",
  "athlete",
  "atmosphere",
  "attach",
  "attempt",
  "attendance",
  "attitude",
  "attorney",
  "attract",
  "audience",
  "authentic",
  "authority",
  "autobiography",
  "automatic",
  "automobile",
  "autumn",
  "available",
  "average",
  "awkward",
  "bachelor",
  "bacteria",
  "balance",
  "balloon",
  "ballot",
  "bamboo",
  "banana",
  "bandage",
  "bankrupt",
  "banquet",
  "bargain",
  "barrel",
  "barrier",
  "basically",
  "battery",
  "beautiful",
  "beginning",
  "behavior",
  "believe",
  "benefit",
  "bicycle",
  "biscuit",
  "blizzard",
  "boundary",
  "bouquet",
  "breathe",
  "brilliant",
  "Britain",
  "brochure",
  "brought",
  "budget",
  "building",
  "bulletin",
  "buoyant",
  "bureau",
  "burglar",
  "business",
  "cafeteria",
  "caffeine",
  "calendar",
  "campaign",
  "cancel",
  "cancellation",
  "candidate",
  "canoe",
  "capacity",
  "capital",
  "capitol",
  "captain",
  "capture",
  "carbohydrate",
  "career",
  "careful",
  "Caribbean",
  "carnival",
  "carriage",
  "cashier",
  "casserole",
  "casualties",
  "catalog",
  "catastrophe",
  "category",
  "cathedral",
  "ceiling",
  "celebrate",
  "celebrity",
  "cellar",
  "cemetery",
  "census",
  "century",
  "ceremony",
  "certain",
  "certificate",
  "challenge",
  "champion",
  "changeable",
  "character",
  "characteristic",
  "charitable",
  "chauffeur",
  "chief",
  "children",
  "chocolate",
  "choir",
  "cholesterol",
  "choose",
  "chromosome",
  "chronicle",
  "circuit",
  "circular",
  "circumference",
  "circumstance",
  "citizen",
  "civilization",
  "classify",
  "client",
  "climate",
  "clothes",
  "coincidence",
  "collar",
  "colleague",
  "colonel",
  "colony",
  "column",
  "comedy",
  "comet",
  "comfort",
  "command",
  "comment",
  "commercial",
  "commission",
  "commit",
  "commitment",
  "committee",
  "communicate",
  "community",
  "comparative",
  "comparison",
  "compassion",
  "compatible",
  "compel",
  "compensate",
  "compete",
  "competition",
  "complain",
  "complement",
  "complete",
  "complex",
  "compliment",
  "component",
  "compose",
  "composition",
  "compound",
  "comprehend",
  "compromise",
  "compute",
  "conceive",
  "concentrate",
  "concern",
  "conclude",
  "concrete",
  "condemn",
  "condition",
  "conduct",
  "conference",
  "confess",
  "confidence",
  "confidential",
  "confirm",
  "conflict",
  "confront",
  "congratulate",
  "congress",
  "conjunction",
  "conquer",
  "conscience",
  "conscientious",
  "conscious",
  "consecutive",
  "consensus",
  "consequence",
  "conservation",
  "conservative",
  "consider",
  "consistent",
  "consonant",
  "conspiracy",
  "constant",
  "constitute",
  "constitution",
  "construct",
  "consult",
  "consumer",
  "contact",
  "contain",
  "contaminate",
  "contemporary",
  "contempt",
  "content",
  "continent",
  "continue",
  "continuous",
  "contract",
  "contradict",
  "contrary",
  "contrast",
  "contribute",
  "control",
  "controversy",
  "convenience",
  "convention",
  "conversation",
  "convert",
  "convince",
  "cooperate",
  "coordinate",
  "corporation",
  "correspond",
  "corridor",
  "council",
  "counsel",
  "counterfeit",
  "country",
  "courageous",
  "course",
  "courtesy",
  "cousin",
  "coverage",
  "creature",
  "credible",
  "crisis",
  "criteria",
  "criterion",
  "critical",
  "criticize",
  "crucial",
  "crystal",
  "cuisine",
  "culture",
  "curiosity",
  "curious",
  "currency",
  "current",
  "curriculum",
  "customer",
  "cylinder",
  "damage",
  "dangerous",
  "daughter",
  "debris",
  "decade",
  "deceive",
  "decent",
  "decimal",
  "decision",
  "declaration",
  "decline",
  "decorate",
  "decrease",
  "dedicate",
  "defendant",
  "defense",
  "deficit",
  "define",
  "definite",
  "definitely",
  "definition",
  "degree",
  "delay",
  "deliberate",
  "delicious",
  "delight",
  "democracy",
  "democratic",
  "demonstrate",
  "denounce",
  "density",
  "department",
  "dependent",
  "deposit",
  "depreciate",
  "depression",
  "depth",
  "descend",
  "descendant",
  "describe",
  "description",
  "desert",
  "deserve",
  "design",
  "desirable",
  "desperate",
  "despite",
  "dessert",
  "destination",
  "destroy",
  "destruction",
  "detail",
  "detect",
  "determine",
  "develop",
  "device",
  "diabetes",
  "diagnose",
  "diagram",
  "dialogue",
  "diameter",
  "diamond",
  "diary",
  "dictionary",
  "different",
  "difficult",
  "dilemma",
  "dimension",
  "diminish",
  "dinosaur",
  "diploma",
  "direction",
  "directly",
  "director",
  "disappear",
  "disappoint",
  "disastrous",
  "discipline",
  "discover",
  "discrepancy",
  "discuss",
  "disease",
  "disguise",
  "dishonest",
  "dismiss",
  "disorder",
  "dispatch",
  "display",
  "dispute",
  "disqualify",
  "dissatisfied",
  "dissolve",
  "distance",
  "distinct",
  "distinguish",
  "distort",
  "distribute",
  "district",
  "disturb",
  "diverse",
  "divide",
  "division",
  "document",
  "dollar",
  "domain",
  "domestic",
  "dominant",
  "dominate",
  "donation",
  "dormitory",
  "doubt",
  "doubtful",
  "dozen",
  "duplicate",
  "durable",
  "earnest",
  "earthquake",
  "economic",
  "economy",
  "ecosystem",
  "educate",
  "effect",
  "efficient",
  "effort",
  "eighth",
  "either",
  "elaborate",
  "elastic",
  "elderly",
  "election",
  "electric",
  "electricity",
  "elegant",
  "elementary",
  "elephant",
  "elevate",
  "eligible",
  "eliminate",
  "ellipse",
  "embarrass",
  "embassy",
  "emerge",
  "emergency",
  "eminent",
  "emotion",
  "emphasis",
  "emphasize",
  "empire",
  "employ",
  "employee",
  "enable",
  "enclose",
  "encounter",
  "encourage",
  "endeavor",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "engineer",
  "enhance",
  "enormous",
  "enough",
  "enroll",
  "ensure",
  "enterprise",
  "entertain",
  "enthusiasm",
  "entire",
  "entrance",
  "entrepreneur",
  "entry",
  "envelope",
  "environment",
  "episode",
  "equal",
  "equation",
  "equator",
  "equipment",
  "equivalent",
  "erase",
  "erode",
  "erosion",
  "error",
  "escape",
  "especially",
  "essential",
  "establish",
  "estate",
  "estimate",
  "eternal",
  "ethical",
  "ethnic",
  "etiquette",
  "evacuate",
  "evaluate",
  "eventually",
  "evidence",
  "evident",
  "evil",
  "evoke",
  "evolution",
  "evolve",
  "exaggerate",
  "examine",
  "example",
  "exceed",
  "excellent",
  "except",
  "exception",
  "excerpt",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "executive",
  "exercise",
  "exhaust",
  "exhibit",
  "exist",
  "existence",
  "expand",
  "expect",
  "expedition",
  "expel",
  "expense",
  "expensive",
  "experience",
  "experiment",
  "expert",
  "explain",
  "explode",
  "exploit",
  "explore",
  "export",
  "expose",
  "express",
  "extend",
  "extension",
  "extensive",
  "extent",
  "exterior",
  "external",
  "extinct",
  "extra",
  "extraordinary",
  "extreme",
  "fabric",
  "fabulous",
  "facility",
  "factor",
  "factory",
  "faculty",
  "failure",
  "faint",
  "familiar",
  "families",
  "famous",
  "fantastic",
  "farther",
  "fascinate",
  "fashion",
  "fatal",
  "fatigue",
  "faucet",
  "favorable",
  "favorite",
  "feasible",
  "feature",
  "February",
  "federal",
  "feminine",
  "fertile",
  "fiber",
  "fiction",
  "fierce",
  "fifteen",
  "fifth",
  "figure",
  "final",
  "finance",
  "financial",
  "flourish",
  "foreign",
  "foremost",
  "foresee",
  "forest",
  "forfeit",
  "forgive",
  "formal",
  "former",
  "formula",
  "fortunate",
  "fortune",
  "forward",
  "fossil",
  "foundation",
  "fountain",
  "fourteen",
  "fourth",
  "fragile",
  "fragment",
  "frame",
  "framework",
  "freight",
  "frequently",
  "friend",
  "frighten",
  "frontier",
  "frown",
  "frozen",
  "fruit",
  "frustrate",
  "fuel",
  "fulfill",
  "function",
  "fundamental",
  "funeral",
  "furniture",
  "further",
  "fusion",
  "future",
  "gadget",
  "galaxy",
  "gallery",
  "gallon",
  "garbage",
  "garden",
  "gasoline",
  "gather",
  "gauge",
  "gender",
  "general",
  "generate",
  "generous",
  "genius",
  "gentle",
  "genuine",
  "geography",
  "geology",
  "geometry",
  "gesture",
  "ghost",
  "giant",
  "giraffe",
  "glacier",
  "glamorous",
  "glimpse",
  "global",
  "glorious",
  "glossary",
  "govern",
  "government",
  "governor",
  "gracious",
  "gradual",
  "graduate",
  "grain",
  "grammar",
  "granite",
  "grateful",
  "gratitude",
  "gravity",
  "grease",
  "greatest",
  "grieve",
  "grocery",
  "grotesque",
  "guarantee",
  "guard",
  "guardian",
  "guerrilla",
  "guess",
  "guidance",
  "guide",
  "guilty",
  "guitar",
  "gymnasium"
]
